<div class="sign-in-wrapper">
  <button mat-button type="button" class="lang-toggle-btn" (click)="toggleLanguage()">
    {{ 'lang' | translate }}
  </button>
  @if (!mfaResolver()) {
    <app-sign-in-card
      [forgotPassword]="['../', DAMO_AUTH_PATHS.FORGOT_PASSWORD]"
      (signIn)="signIn($event.email, $event.password)"
      [loading]="loading()"
      [errorMessage]="errorMessage()"
    ></app-sign-in-card>
    <app-info-card [info]="'https://www.damotech.com/software/watch-the-demo-video-lp'"></app-info-card>
  } @else {
    <mat-card class="mfa-card">
      <mat-card-title>{{ 'auth.mfa.title' | translate }}</mat-card-title>
      <mat-card-content>
        <p>{{ 'auth.mfa.description' | translate }}</p>
        <form [formGroup]="mfaForm" (ngSubmit)="submitMfa()">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'auth.mfa.code' | translate }}</mat-label>
            <input matInput inputmode="numeric" autocomplete="one-time-code" maxlength="6" formControlName="code" />
            @if (mfaForm.controls.code.hasError('required') || mfaForm.controls.code.hasError('pattern')) {
              <mat-error>{{ 'auth.mfa.invalid' | translate }}</mat-error>
            }
          </mat-form-field>
          <button mat-flat-button color="primary" type="submit" class="btn" [disabled]="loading()">
            @if (loading()) {
              <mat-spinner diameter="20"></mat-spinner>
            } @else {
              {{ 'auth.mfa.submit' | translate }}
            }
          </button>
          <button mat-button type="button" [disabled]="loading()" (click)="cancelMfa()">{{ 'auth.mfa.cancel' | translate }}</button>
        </form>
      </mat-card-content>
      @if (errorMessage()) {
        <p class="error-message">{{ errorMessage() }}</p>
      }
    </mat-card>
  }
</div>
